export const COMPARISON_INSURER_DATA_TEMPLATE_FILE_NAME = 'Comparison_Insurer_Data_Template';
export const COMPARISON_INSURER_DATA_FILE_STRUCTURE: Array<{
  headerTitle: string;
  fieldName: string;
}> = [
  {
    headerTitle: 'Firstname *',
    fieldName: 'employee.name_first',
  },
  {
    headerTitle: 'Name Prefix',
    fieldName: 'employee.name_prefix',
  },
  {
    headerTitle: 'Lastname *',
    fieldName: 'employee.name_last',
  },
  {
    headerTitle: 'Birthdate (dd-mm-yyyy)',
    fieldName: 'employee.date_birth',
  },
  {
    headerTitle: 'Gender (e.g. male/female/unknown)',
    fieldName: 'employee.gender',
  },
  {
    headerTitle: 'Email',
    fieldName: 'employee.email',
  },
  {
    headerTitle: 'BSN *',
    fieldName: 'employee.bsn',
  },
  {
    headerTitle: 'Civil Status (e.g. single/married/living-together)',
    fieldName: 'employee.civil_status',
  },
  {
    headerTitle: 'Employee Number',
    fieldName: 'employee.number',
  },
  {
    headerTitle: 'Employment Start Date * (dd-mm-yyyy)',
    fieldName: 'employment.start',
  },
  {
    headerTitle: 'Employment End Date (dd-mm-yyyy)',
    fieldName: 'employment.end',
  },
  {
    headerTitle: 'Wage * (e.g. 1000.00)',
    fieldName: 'employment.wage',
  },
  {
    headerTitle: 'Part-time Percentage * (e.g. 50)',
    fieldName: 'employment.parttime',
  },
  {
    headerTitle: 'Employee Start Date Full Time Annual Wage (dd-mm-yyyy)',
    fieldName: 'employee.startDateFullTimeAnnualWage',
  },
  {
    headerTitle: 'Employee Start Date Part Time Percentage (dd-mm-yyyy)',
    fieldName: 'employee.startDatePartTimePercentage',
  },
];

export const COMPARISON_INSURER_DATA_FILE_HEADERS = COMPARISON_INSURER_DATA_FILE_STRUCTURE.map(
  fileStructure => fileStructure.headerTitle,
);

export interface PayloadData {
  'Firstname *': string;
  'Name Prefix'?: string;
  'Lastname *': string;
  'Birthdate (dd-mm-yyyy)': string;
  'Gender (e.g. male/female/unknown)': string;
  Email: string;
  'BSN *': string;
  'Civil Status (e.g. single/married/living-together)': string;
  'Employee Number': string;
  'Employment Start Date (dd-mm-yyyy)': string;
  'Employment End Date (dd-mm-yyyy)': string;
  'Wage * (e.g. 1000.00)': string;
  'Part-time Percentage * (e.g. 50)': string;
  'Employee Start Date Full Time Annual Wage (dd-mm-yyyy)': string;
  'Employee Start Date Part Time Percentage (dd-mm-yyyy)': string;
}

export type InsurerEmployeeData = {
  socialSecurityNumber: string;
  employmentStartDate: string;
  employmentEndDate: string;
  annualWage: number;
  partTimePercentage: number;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  gender: string | null;
  emailAddress: string | null;
  civilStatus: string | null;
  personnelNumber: string | null;
  startDateFullTimeAnnualWage: string | null;
  startDatePartTimePercentage: string | null;
};

export type UploadInsurerData = {
  comparisonId: string;
  connectionId: string;
  employeeData: InsurerEmployeeData[];
};
